export default {
  auth: () => import("/opt/buildhome/repo/apps/web/layouts/auth.vue").then(m => m.default || m),
  default: () => import("/opt/buildhome/repo/apps/web/layouts/default.vue").then(m => m.default || m),
  "learning-session": () => import("/opt/buildhome/repo/apps/web/layouts/learningSession.vue").then(m => m.default || m)
}